
import { Chip, Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useLotesStore, useModalStore } from "../../../stores";
import { separadorMillares } from "../../../hooks";
import { fechaConHora } from "../../../helpers/prepararFecha";



const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaLotesStock = ({ data, chagePage=() => {}, page=0, }) => {


    const { totalLotes, setActivarLote } = useLotesStore();
    const { modalFormToggle } = useModalStore();


    const handleEditar = (valor) => {
        setActivarLote(valor);
        modalFormToggle(true);
    }


    return (
        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalLotes / +paginado)} disabled={Math.ceil(totalLotes / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'25%'}}>Ingreso</TableCell>
                        <TableCell sx={{width:'15%'}}>Cantidad</TableCell>
                        <TableCell sx={{width:'20%'}}>Valor U.</TableCell>
                        <TableCell sx={{width:'20%'}}>Estado</TableCell>
                        <TableCell sx={{width:'15%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( ( a ) => (
                    <TableRow  key={ a._id }>
                        <TableCell>{ fechaConHora(a?.fechaIngreso) }</TableCell>
                        <TableCell>{ a.cantidadDisponible }</TableCell> 
                        <TableCell>{ `$${separadorMillares(a.precioUnitario)}` }</TableCell>
                        <TableCell>
                            <Chip variant="filled" size="small"
                                label={a.estado ? "Activo" : "Inactivo"}
                                color={a.estado ? "success" : "error"}
                                sx={{ color:"#fff", fontWeight:500 }}
                            />
                        </TableCell>
                        <TableCell>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <TooltipAndIcon
                                    titulo="Editar Lote"
                                    icono="editar"
                                    color="white"
                                    onClick={ () => handleEditar(a) }
                                />  
                            </Stack>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>
        
        :   <MensajeAlertaDanger titulo='No hay lotes de este producto disponible...' />
        }
        </>
    )
}